import React, { FC } from 'react'

import { Page, PageContent } from 'common'
import { HeaderSkeleton } from 'components/header'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import {
  CheckboxAndButtonContainer,
  CheckboxContainer,
  CheckboxContent,
  PrivacyPoliciesContainer,
  PrivacyPolicyButtonContainer,
} from '../styles/privacyPolicyAcceptanceView.styles'

export const PrivacyPolicyAcceptanceContentSkeleton = () => (
  <PageContent style={{ justifyContent: 'space-between' }}>
    <PrivacyPoliciesContainer>
      <section>
        <PrivacyPolicyButtonContainer>
          <Skeleton height="1.5rem" width="8.375rem" />
          <Skeleton height="1.5rem" width="1.5rem" style={{ borderRadius: '50%' }} />
        </PrivacyPolicyButtonContainer>
      </section>
      <section />
    </PrivacyPoliciesContainer>
    <CheckboxAndButtonContainer>
      <CheckboxContainer>
        <CheckboxContent>
          <Skeleton height="1rem" width="80%" />
          <Skeleton height="1rem" width="5%" />
        </CheckboxContent>
      </CheckboxContainer>
      <Skeleton height="3rem" width="100%" />
    </CheckboxAndButtonContainer>
  </PageContent>
)

export const PrivacyPolicyAcceptanceSkeleton: FC = () => (
  <Page>
    <HeaderSkeleton />
    <PrivacyPolicyAcceptanceContentSkeleton />
  </Page>
)
